import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../../../components/button";
import {
  ACCOUNT_SWITCH_MODAL,
  AccountSwitchModal,
} from "../../../layouts/loggedLayout/modals/switcher/accountSwitchModal";
import { useModal } from "../../../hooks/useModal";
import { useSelector } from "react-redux";

function SettingsEntry({ path, children, icon }) {
  return (
    <Link
      to={path}
      className={
        "bg-white hover:bg-blue-50 hover:outline outline-blue-200 cursor-pointer p-5 py-10 gap-5 flex flex-col rounded text-center"
      }
    >
      <div className={"text-blue-200"}>
        <span className={"fa fa-" + icon} style={{ fontSize: 50 }} />
      </div>
      <div>{children}</div>
    </Link>
  );
}

export function SettingsHomePage() {
  let { openModal, checkModal } = useModal();
  const session = useSelector((state) => state.session);
  return (
    <div className={"flex flex-col gap-3 p-3"}>
      {" "}
      <div className={"flex"}>
        <h2 className={"font-bold flex items-center flex-grow"}>
          {checkModal(ACCOUNT_SWITCH_MODAL) && <AccountSwitchModal />}
          <div
            className={
              "bg-white flex gap-3 items-center sm:py-3 cursor-pointer p-3 hover:bg-blue-100  rounded"
            }
            style={{ minWidth: 200 }}
            onClick={() => openModal(ACCOUNT_SWITCH_MODAL)}
          >
            <div
              className={
                " md:block whitespace-nowrap overflow-hidden overflow-ellipsis flex-grow"
              }
              style={{ maxWidth: 150 }}
            >
              {session.account?.companyName}
            </div>
            <div>
              <span className={"fa fa-repeat"} />
            </div>
          </div>
        </h2>
      </div>
      <div className={"grid grid-cols-2 md:grid-cols-3 gap-3"}>
        <SettingsEntry icon={"building"} path={"company"}>
          Company
        </SettingsEntry>
        <SettingsEntry icon={"users"} path={"team"}>
          Team
        </SettingsEntry>
        <SettingsEntry icon={"bank"} path={"accounting"}>
          Accounting
        </SettingsEntry>
        <SettingsEntry icon={"bolt"} path={"integrations"}>
          Integrations
        </SettingsEntry>
        <SettingsEntry icon={"money-bill"} path={"billing"}>
          Billing
        </SettingsEntry>
        <SettingsEntry icon={"question-circle"} path={"help"}>
          Help
        </SettingsEntry>
      </div>
    </div>
  );
}
